import Vue from 'vue'
import Router from 'vue-router'
import houseExpropriation from '@/page/house-expropriation'
import About from '@/page/about'
import notfound from '@/page/errorPage/404'
import Layout from '../layout/Index';
import application from './application';
Vue.use(Router)

let router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: [
    {
      path: '/', redirect: { name: "public" }
    },
    {
      path: '/public',
      name: 'public',
      component: Layout,
      children: [
        ...application
      ]
    },
    {
      path: '/404',
      name: '404',
      component: notfound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
//       if (sessionStorage.getItem('token')) {  // 通过 sessionStorage获取当前的 token 是否存在
//           next();
//       }
//       else {
//           next({
//               path: '/house' // 将跳转的路由 path 作为参数，登录成功后跳转到该路由
//           })
//       }
//   }
//   else {
//       next();
//   }
// })
export default router


// WEBPACK FOOTER //
// ./src/router/index.js